module.exports = __webpack_public_path__ + "img/Group 16.fcac9f16.svg";